export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticProgressBar.vue?vue&type=template&id=a2fd6094"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-progress-bar/VuesticProgressBar.vue?vue&type=template&id=a2fd6094
// module id = y9we
// module chunks = 41